import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { EditCourseStoreModule } from "../components/edit-course/store";

@NgModule({
  imports: [CommonModule, EditCourseStoreModule],
})
export class CoursesStoreModule {}
